import { KandidatResponse } from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function kandidat(KANDIDAT_ID: number): Promise<KandidatResponse> {
  const res = await ApiClient.get(
    `/Kandidat?KANDIDAT_ID=${KANDIDAT_ID}`
  );
  return res.data;
}

export const useFetchKandidat = mutationWrapper(kandidat);
